/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { CheckList, CheckListFromJSON, CheckListToJSON } from '@/requests/mainApi';

/**
 *
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
  /**
   *
   * @type {Array<CheckList>}
   * @memberof InlineResponse20016
   */
  results: Array<CheckList>;
}

export function InlineResponse20016FromJSON(json: any): InlineResponse20016 {
  return InlineResponse20016FromJSONTyped(json, false);
}

export function InlineResponse20016FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20016 {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    results: (json['data'] as Array<any>).map(CheckListFromJSON),
  };
}

export function InlineResponse20016ToJSON(value?: InlineResponse20016 | null): any {
  if (value === undefined) {
    return undefined;
  }

  if (value === null) {
    return null;
  }

  return {
    results: (value.results as Array<any>).map(CheckListToJSON),
  };
}
